import { ArrowUpRight, Award, ExternalLink } from "lucide-react";
import type { Advertisement } from "../types";
import { apiSend } from "../services/api";

type SponsoredSectionProps = {
  ads?: Advertisement[];
};

export function SponsoredSection({ ads }: SponsoredSectionProps) {
  const sponsoredAds = ads?.filter(
    (ad) =>
      ad.active !== false &&
      (ad.placement === "homepage_sponsored" ||
        ad.placement === "sponsored_feed" ||
        ad.sponsor_name)
  );

  if (!sponsoredAds || sponsoredAds.length === 0) return null;

  return (
    <section className="mag-sponsored-spotlight-section" aria-label="Sponsored Intelligence & Partner Reports">
      <div className="mag-section-header">
        <div className="mag-section-title-wrap">
          <Award size={16} className="text-amber-600" />
          <h2 className="mag-section-title">SPONSORED INTELLIGENCE & INDUSTRY SPOTLIGHT</h2>
        </div>
        <span className="mag-partner-disclosure">PAID BRAND COLLABORATIONS</span>
      </div>

      <div className="mag-sponsored-grid">
        {sponsoredAds.map((ad) => {
          const trackClick = () => {
            apiSend(`/api/advertisements/${ad.id}/event`, {
              method: "POST",
              body: JSON.stringify({ event_type: "click", placement: ad.placement })
            }).catch(() => undefined);
          };

          if (ad.ad_type === "html" && ad.html_content) {
            return (
              <div key={ad.id} className="mag-sponsored-card html-style" onClick={trackClick}>
                <div dangerouslySetInnerHTML={{ __html: ad.html_content }} />
              </div>
            );
          }

          return (
            <a
              key={ad.id}
              href={ad.destination_url}
              target="_blank"
              rel="sponsored noopener noreferrer"
              onClick={trackClick}
              className="mag-sponsored-card"
            >
              <div className="mag-sponsored-card-header">
                <div className="mag-sponsor-badge-group">
                  <span className="mag-sponsor-kicker">COMMERCIAL REPORT</span>
                  {ad.sponsor_name && (
                    <span className="mag-sponsor-name">By {ad.sponsor_name}</span>
                  )}
                </div>
                <ArrowUpRight size={16} className="mag-sponsor-icon" />
              </div>

              <div className="mag-sponsored-card-body">
                <h3 className="mag-sponsored-card-title">{ad.headline || ad.name}</h3>
                {ad.body_text && (
                  <p className="mag-sponsored-card-desc">{ad.body_text}</p>
                )}
              </div>

              <div className="mag-sponsored-card-footer">
                <span className="mag-sponsored-cta">
                  <span>{ad.cta_text || "Explore Briefing"}</span>
                  <ExternalLink size={12} />
                </span>
              </div>
            </a>
          );
        })}
      </div>
    </section>
  );
}
